import React from 'react'
import styles from './exInventoryUpload.module.css'
import bomstyles from '../BomManage/bomManage.module.css'
import { Back, Upload } from '../../../Svg'
import { useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { exportDataExcel } from '../../utils/utils'
import * as XLSX from "xlsx";
import { deletexcessPreviewData, setexcessFileName, setexcessPreview } from '../../redux/excessSlice'

const ExInventoryUpload = () => {

    const dispacth = useDispatch()
    const navigate = useNavigate()
    const { filename, excesspreview } = useSelector((state) => state.excess)

    const downloadtemplate = () => {
        const data = [
            {
                productNumber: "",
                quantity: "",
                manufacturer: ""
            }
        ]
        exportDataExcel(data, 'excesspo')
    }


    // const handleFileUpload = (e) => {
    //     const file = e.target.files[0];
    //     // setFile(file)
    //     dispacth(setexcessFileName(file))
    //     if (file) {
    //         const reader = new FileReader();

    //         reader.onload = (event) => {
    //             const binaryStr = event.target.result;
    //             const workbook = XLSX.read(binaryStr, { type: "binary" });
    //             const sheetName = workbook.SheetNames[0];
    //             const sheet = workbook.Sheets[sheetName];
    //             const jsonData = XLSX.utils.sheet_to_json(sheet);
    //             dispacth(setexcessPreview(jsonData))
    //         };

    //         reader.readAsBinaryString(file);
    //     }
    // };

    const handleFileUpload = (e) => {
        const file = e.target.files[0];
        dispacth(setexcessFileName(file));

        if (file) {
            const reader = new FileReader();

            reader.onload = (event) => {
                const binaryStr = event.target.result;
                const workbook = XLSX.read(binaryStr, { type: "binary" });
                const sheetName = workbook.SheetNames[0];
                const sheet = workbook.Sheets[sheetName];

                // Get raw array of rows (2D array)
                const data = XLSX.utils.sheet_to_json(sheet, { header: 1 });

                let jsonData = data.filter((item) => item.length > 0);

                // Dynamically assign column keys like column0, column1, etc.
                const normalizedData = jsonData.map((row, index) => {
                    const rowObject = { id: index + 1 };
                    row.forEach((cell, colIndex) => {
                        rowObject[`column${colIndex}`] = cell;
                    });
                    return rowObject;
                });

                console.log("Normalized Raw Data:", normalizedData);
                dispacth(setexcessPreview(normalizedData));
            };

            reader.readAsBinaryString(file);
        }
    };

    return (
        <div className={styles.inventoryContainer}>
            <div>
                <button className={styles.compBtn} onClick={() => navigate(-1)}><Back />Back to previous page</button>
            </div>

            <div className={styles.headerLine}>Upload the excess inventory stock</div>
            <div className={bomstyles.displayFlex}>
                <div className={bomstyles.bomContentBox}>
                    <p>Choose the file and sheet to upload. At minimum you will need to include part numbers and quantities for each.</p>
                    <h3>File Upload</h3>
                    <label htmlFor="doc">
                        <div className={bomstyles.bomInnerBox}>
                            <Upload />
                            {filename ?
                                <span>{filename?.name}</span>
                                :
                                <span>Choose the file and sheet to upload</span>
                            }
                            <button className={bomstyles.chooseBtn}>Choose File</button>
                            <input
                                id='doc'
                                type="file"
                                accept=".xlsx, .xls"
                                onChange={handleFileUpload}
                                style={{ display: 'none' }}
                            />
                        </div>
                    </label>
                    <span>We support .xls, .xlsx and .csv files under 4MB</span>
                    <div className={bomstyles.displayFlex2}>
                        <button className={bomstyles.cancelBtn} onClick={() => dispacth(deletexcessPreviewData())}>Cancel</button>
                        <button className={bomstyles.submitBtn}
                            onClick={() => navigate(`/fileUploadPreview`, { state: { data: excesspreview, from: 'excess' } })}
                            disabled={excesspreview?.length <= 0}
                            style={{ background: excesspreview?.length <= 0 ? '#8463d1' : '#512DA8' }}
                        >
                            Submit
                        </button>

                    </div>
                </div>
                <div className={bomstyles.bomTabsCol2}>
                    <p>Submit part numbers in bulk by uploading your spreadsheet or copying and pasting them here.
                        File Upload Steps:
                        <ol>
                            <li>Upload your spreadsheet.</li>
                            <li> Map the required data columns.</li>
                            <li> Purchase your parts, get a quote or add them to a project list.</li>
                        </ol>
                    </p>
                    {/* <a href='' className={bomstyles.download}>Download our BOM template</a> */}
                    <div onClick={downloadtemplate} className={bomstyles.download} style={{ cursor: 'pointer' }}>Download our  template</div>
                </div>
            </div>

        </div>
    )
}

export default ExInventoryUpload